import { Legend } from '../util-components/legend/legend.js';
import { CheckboxItem } from './checkbox-item.js';
var Checkbox = {
  Item: CheckboxItem,
  Legend: Legend
};
export { Checkbox };